import React from 'react';

export const Dropdown = ({label, value, options, onChange, placeholder}) => {
	return (
		<select
			value={value}
			onChange={onChange}
			className='miDropDown'
		>
			{options.map((option, key) =>
				placeholder === option.label ? (
					<option
						value={options.value}
						key={key}
						selected
					>
						{option.label}
					</option>
				) : (
					<option
						value={option.value}
						key={key}
					>
						{option.label}
					</option>
				)
			)}
		</select>
	);
};
